export default __webpack_public_path__ + "static/media/get-verified.67bca413.png";